<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import PrivateLayout from './layouts/private-layout.vue';
import PublicLayout from './layouts/public-layout.vue';
import { getters as auth } from './services/auth.service';

const route = useRoute();

const layout = computed(() => {
    if (route.meta?.public) return PublicLayout;

    return auth.isAuthenticated ? PrivateLayout : PublicLayout;
});
</script>

<template>
    <div class="evo-flex evo-flex-col evo-w-full evo-h-full evo-min-h-screen">
        <component :is="layout">
            <router-view></router-view>
        </component>
        <div v-if="auth.isLoggingOut" class="hive-logout-overlay" role="status" aria-live="polite">
            <span class="hive-logout-overlay__spinner" aria-hidden="true"></span>
            <p class="hive-logout-overlay__text">Signing out…</p>
        </div>
    </div>
</template>

<style>
.hive-logout-overlay {
    position: fixed;
    inset: 0;
    background: var(--brand-primary, #111827);
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    z-index: 9999;
}

.hive-logout-overlay__spinner {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.2);
    border-top-color: white;
    animation: hive-logout-spin 0.9s linear infinite;
}

.hive-logout-overlay__text {
    font-size: 0.875rem;
    opacity: 0.85;
}

@keyframes hive-logout-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
